import { type QueryFunctionContext } from '@tanstack/react-query'
import { apiGet } from '@/features/shared/utils/dataFetching'
import { type GiftOptionsResponse } from '@/features/purchase/services/GiftCard/types'

export const fetchGiftCardOptions = (context: QueryFunctionContext) => {
  return apiGet<GiftOptionsResponse>({
    config: {
      url: '/marketplace-broker/v1/gifts/options',
    },
    context,
    fetcherName: 'fetchGiftCardOptions',
  })
}
